import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from './material.module';
import { SharedModule } from '../shared/shared.module';

import { MenuSeguridadComponent } from '@components/pages/seguridad/menu-seguridad/menu-seguridad.component';
import { RolesAdministracionComponent } from '@components/pages/seguridad/roles-administracion/roles-administracion.component';
import { PermisosAdministracionComponent } from '@components/pages/seguridad/permisos-administracion/permisos-administracion.component';
import { RolEdicionComponent } from '@components/pages/seguridad/rol-edicion/rol-edicion.component';
import { MenuesAdministracionComponent } from '@components/pages/seguridad/menues-administracion/menues-administracion.component';
import { MenuEdicionComponent } from '@components/pages/seguridad/menu-edicion/menu-edicion.component';
import { TestMenuNuevoComponent } from '@components/pages/seguridad/test-menu-nuevo/test-menu-nuevo.component';

@NgModule({
    declarations: [
        MenuSeguridadComponent,
        RolesAdministracionComponent,
        PermisosAdministracionComponent,
        RolEdicionComponent,
        MenuesAdministracionComponent,
        MenuEdicionComponent,
        TestMenuNuevoComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MaterialModule,
        SharedModule,
    ],
})
export class SeguridadModule {}
